import { parameters } from '../../constants/parameters';
import { Language } from '../../entities/language';
import * as genericApi from './generic-api';

export const list = async (token: string): Promise<Language[]> => {
  const url = `${parameters.api.baseUrl}/languages-crud`;

  return genericApi.listWithoutPagination<Language>(token, url, { is_active: 1, sort: 'LANGUAGE_ID' });
};
